import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableItem } from "@/components/dnd/SortableItem";
import { DeckCardBottom } from "@/components/DeckBuilder/DeckCardBottom";
import { useClientMediaQuery } from "@/lib/hooks/isMobile";
import {
  useDeckCounts,
  useCardOrderIds,
  useSetCardOrderIds,
} from "@/stores/deckStore";
import React from "react";

export const SortableRect = React.memo(function SortableRect({
  handleOpen,
  cardSize = "md",
  disableClick = false,
  setHoveredAACardId,
}: {
  handleOpen: any;
  cardSize?: "md" | "lg";
  disableClick?: boolean;
  setHoveredAACardId: any;
}) {
  const deckCounts = useDeckCounts();
  const items = useCardOrderIds();
  const setItems = useSetCardOrderIds();
  const isMobile = useClientMediaQuery("(max-width: 600px)");
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      distance: 5,
    },
  });
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 5,
    },
  });

  const sensors = useSensors(isMobile ? touchSensor : pointerSensor);

  function handleDragEnd(event: any) {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((items: string[]) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      autoScroll={false}
    >
      <SortableContext items={items} strategy={rectSortingStrategy}>
        {items.map((id: string) => {
          const count = deckCounts.get(id);
          if (!count) return null;
          return (
            <SortableItem key={id} id={id}>
              <DeckCardBottom
                cardSize={cardSize}
                handleOpen={handleOpen}
                aaCardId={id}
                count={count}
                disableClick={disableClick}
                setHoveredAACardId={setHoveredAACardId}
              />
            </SortableItem>
          );
        })}
      </SortableContext>
    </DndContext>
  );
});
